import React from 'react';
import HeroSection from '../HeroSection';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO, { organizationSchema } from '../SEO';

export default function Intro() {
  return (
    <>
      <SEO
        title='IT Consulting, Cloud & Digital Transformation'
        description='IURIX catalizes your business with expert I.T. consulting, cloud infrastructure, DevOps automation, AI & analytics, and cybersecurity solutions.'
        path='/'
        jsonLd={organizationSchema}
      />
      <main>
        <HeroSection />
      </main>
      <Copyrights />
      <Footer />
    </>
  );
}

